import { transportationModesEntry } from 'redux/types/storeTypes';
import * as TransportationModesActions from '../types/transportationModesTypes';

const initialState : transportationModesEntry = {
  loading: false,
  error: undefined,
  items: []
};

const transportationModesReducer = (
  state = initialState,
  action: { [key: string]: any }
) => {
  switch (action.type) {
    case TransportationModesActions.GET_TRANSPORTATION_MODES_START:
      return {
        ...state,
        error: undefined,
        loading: true,
      };

    case TransportationModesActions.GET_TRANSPORTATION_MODES_SUCCESS:
      return {
        ...state,
        items: Array.isArray(action.payload.transportation_modes)
          ? action.payload?.transportation_modes
          : state.items,
        loading: false,
      };

    case TransportationModesActions.GET_TRANSPORTATION_MODES_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    default:
      return state;
  }
};

export default transportationModesReducer;
